module.exports = __webpack_public_path__ + "static/media/009_aligncare.d2ff16f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp_org/009_aligncare.png
// module id = 545
// module chunks = 0